import React from 'react';
import { render } from 'react-dom';
import App from './containers/App';
import './index.css';
import '@deque/cauldron-react';
import '@deque/cauldron-styles';

render(<App />, document.getElementById('app'));
